import angular from "angular";
import _ from "lodash";
import {IAppRootScopeService} from "@app/app.definition";
import {BroadcastService} from "@common/service/broadcast.service";
import {UtilityService} from "@common/service/util.service";
import {JavaApiAdapterService} from "@common/apiadapter/javaapi.service";
import {SnackbarService} from "@common/service/snackbar.service";
import {CommonService} from "@common/common.service";
import {CacheService} from "@common/service/cache.service";
import {APIService} from "@common/api/api.service";
import {FieldService} from "@common/service/field.service";

export class EcvFormsRev {
    formConfig: any;
    ref: string;
    form: any;
    schema: any;
    model: any;
    viewOnly: boolean;
    $validationProvider: any;
    formLoaded: boolean;
    formLoadingError: boolean;
    subject;
    timePckrFlds = [];
    tpUpd;
    reqFlds;
    formUtils;
    cstmAttrFlds;
    promise;

    static $inject = ["$rootScope", "$scope", "$injector", "BroadcastService",
        "$timeout", "UtilityService", "$filter", "$q", "FieldService", "ApiAdapterService", "APIService", "CacheService",
        "$uibModal", "CommonService", "$moment", "SnackbarService", "$state", "$interval"];

    constructor(private $rootScope : IAppRootScopeService, private $scope : angular.IScope, private $injector : angular.auto.IInjectorService, private BroadcastService : BroadcastService,
                private $timeout : angular.ITimeoutService, private UtilityService : UtilityService, private $filter, private $q : angular.IQService, private FieldService : FieldService, private ApiAdapterService : JavaApiAdapterService,
                private APIService : APIService, private CacheService : CacheService, private $uibModal, private $_com : CommonService, private moment,
                private $_snack : SnackbarService, private $state : angular.ui.IStateService, private $interval : angular.IIntervalService) {
        this.$validationProvider = $injector.get('$validation');
        this.formLoaded = false;
        this.formLoadingError = false;
        this.BroadcastService.registerCallBack('edit-team', this.$scope.$id, (edit) => {
            var config = _.cloneDeep(this.formConfig);
            config.readOnly = !edit;
            var parsedForm = this.formUtils.parseForm(config, !edit, this.subject);
            this.form = parsedForm.form;
            this.schema = parsedForm.schema;
            this.model = parsedForm.model;
        });
        this.BroadcastService.registerCallBack('disable-enable', this.$scope.$id, (enable, setModel) => {
            var config = _.cloneDeep(this.formConfig);
            config.readOnly = !enable;
            var refreshForm = () => {
                var parsedForm = this.formUtils.parseForm(config, !enable, this.subject, null, null, null, null, null, setModel, true);
                this.form = parsedForm.form;
                this.schema = parsedForm.schema;
                this.model = parsedForm.model;
            }
            if (this.formUtils.pendingParsedFields == 0) {
                refreshForm();
            } else {
                //Sometimes when the form is getting initialised there is a call for enabling the form. So before the first
                // parseForm call ends the second parseForm call gets called which causes discrepancies in the pendingParsedFields counter.
                // Hence adding an interval to wait till first parsing gets over.
                this.$interval.cancel(this.promise);
                this.promise = this.$interval(
                    () => {
                        if (this.formUtils.pendingParsedFields == 0) {
                            this.$interval.cancel(this.promise);
                            refreshForm();
                        }
                    }, 1000);
            }
        });
        $scope.$on("$destroy", function () {
            BroadcastService.removeCallBack('edit-team', $scope.$id);
            BroadcastService.removeCallBack('disable-enable', $scope.$id);
        });
    }

    init = (): void => {
        this.formLoaded = false;
        this.formLoadingError = false;
        var config = _.cloneDeep(this.formConfig);
        config.readOnly = this.viewOnly;
        var parsedForm = this.formUtils.parseForm(config, this.viewOnly, this.subject);
        this.form = parsedForm.form;
        this.schema = parsedForm.schema;
        this.model = parsedForm.model;
        this.timePckrFlds = parsedForm.timePckrFlds;
        this.reqFlds = parsedForm.reqFlds;
        this.cstmAttrFlds = parsedForm.cstmAttrFlds;
        console.log("FORM: ", parsedForm);
        this.formLoaded = true;
        this.$timeout(() => {
            if (this.timePckrFlds.length > 0) {
                this.tpUpd = this.$rootScope.$on('mdpTimePickerUpdated', (event, data) => {
                    this.timePckrFlds.forEach(tp => {
                        let t = tp.key[0];
                        this.model[t] = this.UtilityService.resetTimePicker(t, this.model[t]);
                    });
                });
            }
        }, 500);
    }
}

function forms(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/customAttributeTemplate/components/customAttribute/customAttribute.directive.html',
        replace: true,
        controller: EcvFormsRev,
        controllerAs: 'formsVm',
        scope: true,
        bindToController: {
            'formConfig': '=',
            'formUtils': '=',
            'viewOnly': '=',
            'subject': '=?',
            'model': '=?',
            'reqFlds': '=?',
            'cstmAttrFlds': '=?'
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: EcvFormsRev): void => {
            controller.init();
            scope.$watch(() => {
                return controller.formConfig;
            }, (newVal, oldVal) => {
                if (newVal != oldVal) {
                    controller.init();
                }
            });
        }
    }
}

angular.module('eCareVault.customAttributeTemplate').directive('ecvFormsRevised', forms);

